import { axiosInstance } from "../../../../config/api/Axios";

export const requestCompanyDataApi = (companyData) => axiosInstance.post(`/company/data/requests`, companyData);

export const getRequestedCompaniesApi = (orgId, filter) =>
    axiosInstance.get(`organizations/${orgId}/company-requests`, { params: { ...filter } });
